import { Component } from "@angular/core";
import { AuthService } from "../../core/authentication/services/auth.service";
import { Location } from "@angular/common";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { PwaInstallerComponent } from "../../shared/modules/pwa-installer/pwa-installer.component";

@Component({
    selector: "app-footer",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"],
    standalone: true,
    imports: [
        PwaInstallerComponent,
        RouterLink,
        RouterLinkActive,
    ],
})
export class AppFooterComponent {
  year = new Date().getFullYear();
  isLoggedIn = this.auth.isLoggedIn;

  constructor(private auth: AuthService, private _location: Location) {}

  public login(): void {
    this.auth.redirectToLogin();
  }

  public signup(): void {
    this.auth.redirectToRegister();
  }

  public logout(): void {
    this.auth.logout();
  }

  public isFrontPage(): boolean {
    return this._location.isCurrentPathEqualTo("");
  }
}
